<template>
  <a-layout-header
    :style="{
      position: navigationmode,
      zIndex: 100,
      width: navigationmode === 'fixed' ? headerWidth : '100%',
      height: headerHeight + 'px'
    }"
    class="own-header"
  >
    <div class="header-context">
      <a-icon
        :type="collapsed ? 'menu-unfold' : 'menu-fold'"
        class="trigger"
        @click="() => (collapsed = !collapsed)"
      />
      <div class="page-context">
        <span class="eyebrow">WTWS · ERP</span>
        <strong>{{ currentTitle }}</strong>
      </div>
    </div>
    <div class="header-right">
      <a-dropdown :trigger="['click']">
        <div class="user-entry" @click="e => e.preventDefault()">
          <span class="greeting">{{ timeFix() }}，</span>
          <span class="avatar">
            {{ (user.displayName || user.loginName || "用").slice(0, 1) }}
          </span>
          <a class="ant-dropdown-link">
            {{ user.displayName || user.loginName || "用户名" }}
            <a-icon type="down" />
          </a>
        </div>
        <a-menu slot="overlay">
          <a-menu-item @click="resetPwd">
            修改密码
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item @click="logout">
            退出登录
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>

    <!-- 修改密码 -->
    <a-modal
      :confirm-loading="confirmLoading"
      :visible="visible"
      title="修改密码"
      @cancel="handleCancel"
      @ok="handleOk"
    >
      <a-form-model
        ref="form"
        :label-col="{ span: 5 }"
        :model="form"
        :rules="rules"
        :wrapper-col="{ span: 19 }"
        labelAlign="left"
      >
        <a-form-model-item ref="oldPwd" label="旧密码" prop="oldPwd">
          <a-input
            v-model="form.oldPwd"
            allow-clear
            type="password"
            @blur="
              () => {
                $refs.oldPwd.onFieldBlur()
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item ref="newPwd" label="新密码" prop="newPwd">
          <a-input
            v-model="form.newPwd"
            allow-clear
            type="password"
            @blur="
              () => {
                $refs.newPwd.onFieldBlur()
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item ref="rePwd" label="确认密码" prop="rePwd">
          <a-input
            v-model="form.rePwd"
            allow-clear
            type="password"
            @blur="
              () => {
                $refs.rePwd.onFieldBlur()
              }
            "
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout-header>
</template>
<script>
import md5 from "js-md5" // 使用md5加密密码
import { updatepwd } from "@/api/user"
import { timeFix } from "@/utils/utils"
import eventBus from "@/bus"
import { PageSetting } from "@/config"
import { mapGetters } from "vuex"

export default {
  data() {
    // 验证确认密码
    let validateRepasswword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次确认密码"))
      } else if (value !== this.form.newPwd) {
        callback(new Error("两次密码不一致"))
      } else {
        callback()
      }
    }
    // 验证新密码输入
    let validatePasswword = (rule, value, callback) => {
      // 新密码正则验证
      let special = new RegExp(/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/)
      if (value.trim() === "") {
        this.popoverVisible = true
        callback(new Error("请输入密码"))
      } else if (value.includes(" ")) {
        this.popoverVisible = true
        callback(new Error("不能包含空格"))
      } else if (!special.test(value)) {
        this.popoverVisible = true
        callback(new Error("由数字和字母组成，不能包含特殊字符"))
      } else if (value.length < 6 || value.length > 11) {
        this.popoverVisible = true
        callback(new Error("长度为6-11个字符"))
      } else {
        this.popoverVisible = false
        callback()
      }
    }
    return {
      collapsed: false,
      timeFix,
      headerHeight: PageSetting.headerHeight,
      headerWidth: `calc(100% - ${PageSetting.sliderWidth}px)`,
      visible: false,
      confirmLoading: false,
      form: {
        oldPwd: "",
        newPwd: "",
        rePwd: ""
      },
      rules: {
        oldPwd: [
          {
            required: true,
            message: "请输入旧密码",
            trigger: "blur"
          }
        ],
        newPwd: [
          {
            required: true,
            validator: validatePasswword,
            trigger: "blur"
          }
        ],
        rePwd: [
          {
            required: true,
            validator: validateRepasswword,
            trigger: "blur"
          }
        ]
      }
    }
  },
  watch: {
    collapsed: {
      handler(newVal) {
        if (newVal) {
          this.headerWidth = `calc(100% - ${PageSetting.collapsedWidth}px)`
        } else {
          this.headerWidth = `calc(100% - ${PageSetting.sliderWidth}px)`
        }
        eventBus.$emit("collapsed", newVal)
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters(["navigationmode", "user"]),
    currentTitle() {
      const matched = this.$route.matched || []
      const current = matched[matched.length - 1]
      return (
        (this.$route.meta && this.$route.meta.title) ||
        (current && current.meta && current.meta.title) ||
        this.$route.name ||
        "业务工作台"
      )
    }
  },
  mounted() {
    if (document.body.clientWidth <= 1600) {
      this.collapsed = true
    }
  },
  methods: {
    resetPwd() {
      this.visible = true
    },
    logout() {
      let _this = this
      _this.$confirm({
        title: "确定退出系统?",
        content: "",
        onOk() {
          return new Promise(resolve => {
            setTimeout(() => {
              _this.$store.dispatch("LogOut")
              resolve()
            }, 1000)
          }).catch(() => {})
        },
        onCancel() {}
      })
    },
    handleOk() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.confirmLoading = true
          updatepwd({
            password: md5(md5(this.form.newPwd) + "wtws"),
            oldPassWord: md5(md5(this.form.oldPwd) + "wtws")
          })
            .then(res => {
              this.confirmLoading = false
              if (res.code === 14) {
                this.$store.dispatch("LogOut", false)
              }
            })
            .catch(() => {
              this.confirmLoading = false
            })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.visible = false
      this.form = {
        oldPwd: "",
        newPwd: "",
        rePwd: ""
      }
      this.$refs.form.clearValidate()
    }
  }
}
</script>
<style lang="scss" scoped>
.own-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0;
  padding-right: 24px !important;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(8px);
  right: 0;
  top: 0;
  transition: all 0.2s;
  border-bottom: 1px solid #eef1f5;

  .header-context {
    display: flex;
    align-items: center;
    height: 100%;
    min-width: 0;
  }

  .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 20px;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.65);
    border-radius: 0 8px 8px 0;
    transition: color 0.2s, background 0.2s;

    &:hover {
      color: #1890ff;
      background: rgba(24, 144, 255, 0.06);
    }
  }

  .page-context {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
    padding-left: 20px;

    &::before {
      position: absolute;
      top: 16px;
      bottom: 16px;
      left: 0;
      width: 1px;
      background: #e7ebf1;
      content: "";
    }

    .eyebrow {
      margin-bottom: 2px;
      color: #9aa6b2;
      font-size: 10px;
      font-weight: 600;
      line-height: 14px;
      letter-spacing: 1.2px;
    }

    strong {
      max-width: 360px;
      overflow: hidden;
      color: #17233d;
      font-size: 15px;
      font-weight: 600;
      line-height: 20px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .header-right {
    display: flex;
    align-items: center;
  }

  .user-entry {
    display: flex;
    align-items: center;
    padding: 6px 10px 6px 12px;
    border-radius: 24px;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background: #f5f7fa;
    }

    .greeting {
      color: rgba(0, 0, 0, 0.45);
      font-size: 13px;
      margin-right: 8px;
    }

    .avatar {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: linear-gradient(135deg, #4dabff, #1677ff);
      color: #fff;
      font-size: 13px;
      font-weight: 600;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
      box-shadow: 0 2px 6px rgba(22, 119, 255, 0.3);
    }

    .ant-dropdown-link {
      color: rgba(0, 0, 0, 0.75);
      font-weight: 500;

      .anticon {
        margin-left: 4px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.35);
      }
    }
  }
}

@media (max-width: 720px) {
  .own-header {
    padding-right: 12px !important;

    .page-context .eyebrow,
    .greeting {
      display: none;
    }
  }
}
</style>
